export default "__VITE_ASSET__BW0bm5N0__"